@if (valueAddedTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="aangiftes">
      @for (item of aangifte.controls; let i = $index; track i) {
        <div [formGroupName]="i">
          @if (this.index === $index) {
            @if (item.get('verzendDatum')?.getRawValue() != null) {
              <div class="row">
                <div class="col-7">
                  <p>Datum ingediend</p>
                </div>
                <div class="col-2">
                  <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                  formControlName="verzendDatum"
                                                  id="verzendDatum"
                                                  label=""
                  >
                  </snelstart-ui-date-form-control>
                </div>
                <div class="col-3"></div>
              </div>
            }
            <div formGroupName="tijdvak">
              <div class="row">
                <div class="col-7">
                  <p>Aanvang tijdvak</p>
                </div>
                <div class="col-2">
                  <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                  formControlName="begindatum"
                                                  id="begindatum"
                                                  label=""
                  >
                  </snelstart-ui-date-form-control>
                </div>
                <div class="col-3"></div>
              </div>
              <div class="row">
                <div class="col-7">
                  <p>Einde tijdvak</p>
                </div>
                <div class="col-2">
                  <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                  formControlName="einddatum"
                                                  id="einddatum"
                                                  label=""
                  >
                  </snelstart-ui-date-form-control>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <p>Betalingskenmerk</p>
              </div>
              <div class="col-2">
                <snelstart-ui-text-form-control class="me-1 custom-input-150"
                                                formControlName="betalingskenmerk"
                                                id="betalingskenmerk"
                >
                </snelstart-ui-text-form-control>
              </div>
              <div class="col-3"></div>
            </div>
            <div formGroupName="omzetHoog">
              <div class="pt-3">
                <div class="row">
                  <div class="col-7 pt-3">
                    <p>Leveringen/diensten hoog tarief</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetHoog"
                                                      label="Omzet"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingHoog"
                                                      label="Omzetbelasting"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div formGroupName="omzetLaag">
              <div>
                <div class="row">
                  <div class="col-7">
                    <p>Leveringen/diensten laag tarief</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetLaag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingLaag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div formGroupName="omzetOverigTarief">
              <div>
                <div class="row">
                  <div class="col-7">
                    <p>Leveringen/diensten overige tarieven, behalve 0%</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetOverigTarief"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetOverigTariefBelasting"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div formGroupName="privegebruik">
              <div>
                <div class="row">
                  <div class="col-7">
                    <p>Privé-gebruik</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetprivegebruik"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingprivegebruik"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <p>Leveringen/diensten 0% of niet bij u belast</p>
              </div>
              <div class="col-2 ps-1">
                <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                  align="right"
                                                  class="me-1 custom-input-150"
                                                  formControlName="omzetNul"
                                                  id="omzetNul"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-3"></div>
            </div>
            <div formGroupName="omzetVerlegdBinnenland">
              <div class="pt-3">
                <div class="row">
                  <div class="col-7">
                    <p>Leveringen/diensten btw naar u verlegd</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetomzetVerlegdBinnenland"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingomzetVerlegdBinnenland"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <p>Leveringen naar landen buiten EU (uitvoer)</p>
              </div>
              <div class="col-2 ps-1">
                <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                  align="right"
                                                  class="me-1 custom-input-150"
                                                  formControlName="leveringenNaarLandenBuitenDeEU"
                                                  id="leveringenNaarLandenBuitenDeEU"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>

              <div class="col-3"></div>
            </div>
            <div class="row">
              <div class="col-7">
                <p>Leveringen naar of diensten in landen binnen EU</p>
              </div>
              <div class="col-2 ps-1">
                <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                  align="right"
                                                  class="me-1 custom-input-150"
                                                  formControlName="leveringenNaarLandenBinnenDeEU"
                                                  id="leveringenNaarLandenBinnenDeEU"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-3"></div>
            </div>
            <div formGroupName="leveringenUitLandenBuitendeEU">
              <div class="pt-3">
                <div class="row">
                  <div class="col-7">
                    <p>Leveringen/diensten uit landen buiten de EU</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetleveringenUitLandenBuitendeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingleveringenUitLandenBuitendeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div formGroupName="leveringenUitLandenBinnenDeEU">
              <div>
                <div class="row">
                  <div class="col-7">
                    <p> Leveringen/diensten uit landen binnen de EU</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzet"
                                                      id="omzetleveringenUitLandenBinnenDeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetbelasting"
                                                      id="omzetbelastingleveringenUitLandenBinnenDeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div class="pt-3">
              <div class="row">
                <div class="col-7">
                  <p>Voorbelasting</p>
                </div>
                <div class="col-2">
                  <div style="height: 20px; width: 160px"></div>
                </div>
                <div class="col-3">
                  <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                    align="right"
                                                    class="me-1 custom-input-150"
                                                    formControlName="voorbelasting"
                                                    id="voorbelasting"
                                                    prefix="€ -"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
            <div class="pt-3">
              <div class="row">
                <div class="col-7">
                  <p><b>Totaal</b></p>
                </div>
                <div class="col-2">
                  <div style="height: 20px; width: 160px"></div>
                </div>
                <div class="col-3">
                  <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                    [calculate]="calculateTotal(i)"
                                                    align="right"
                                                    class="me-1 custom-input-150"
                                                    formControlName="totaal"
                                                    id="totaal"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </form>
}
